import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export default new (class {
	async getAll(facilityId) {
		const response = await axios.get(
			`${API_URL}/api/Cms/ExpenseCategories?facilityId=${facilityId}`,
			{
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			}
		);
		return response.data;
	}
	async getById(ExpenseCategoryId) {
		const url = ExpenseCategoryId
			? `/api/Cms/ExpenseCategory?id=${ExpenseCategoryId}`
			: '/api/Cms/ExpenseCategory';

		const response = await axios.get(`${API_URL}${url}`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async update(expenseCategory) {
		try {
			await axios.put(`${API_URL}/api/Cms/ExpenseCategory`, expenseCategory, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error updating simulation template:', error);
			throw error;
		}
	}
	async deleteById(expenseCategoryId) {
		try {
			await axios.delete(
				`${API_URL}/api/Cms/ExpenseCategory?id=${expenseCategoryId}`,
				{
					withCredentials: true,
					headers: {
						'Cache-control': 'no-cache'
					}
				}
			);
		} catch (error) {
			console.error('Error deleting by ID:', error);
			throw error;
		}
	}
})();
